
import Component from "vue-class-component"
import NachbestellungLogic from "@/logic/bestellung/nachbestellung_logic"
import BstlArtikel from "@/entities/common/bstl_artikel"
import Nachbestellung from "./Nachbestellung.vue"
import Vue from "vue"
import { Watch } from "vue-property-decorator"

@Component
export default class NachbestellungArtikelEdit extends Vue {
  logic: NachbestellungLogic = null

  added(value: BstlArtikel) {
    this.logic.addArtikel(value)
  }

  @Watch("$parent.logic", { immediate: true, deep: false })
  watchParentLogic() {
    this.logic = (this.$parent as Nachbestellung).logic
    this.logic.createdListener = () => {
      if (this.logic.artikel == null) {
        this.logic.reloadArtikel(this.$route.params.id)
      }
    }
  }

  mounted() {
    this.logic = (this.$parent as Nachbestellung).logic
    this.logic.createdListener = () => {
      if (this.logic.artikel == null) {
        this.logic.reloadArtikel(this.$route.params.id)
      }
    }
  }
}
